<dx-tooltip npTooltipDisplay class="toolTip toolTipField">
  <div *dxTemplate="let _ = data; of: 'content'">
    <p>
      {{ text | translate }}
    </p>
    <div *ngIf="showProTooltips" class="nexMartTooltip"></div>
  </div>
</dx-tooltip>
